module.exports = __webpack_public_path__ + "media/images/thumbs/pathophys/6krdNiki0EEGUAyWs2QQsi-4851994e3d5ee11c65a315c0512dc246.jpg";